<div class="rapider-ai-build-information-area">
  <div *ngIf="isBuildInfoExist; else notFoundTemplate">
    <p>{{ versionSummary?.version }}</p>
    <p>{{ versionSummary?.buildDate }}</p>
    <p>{{ versionSummary?.commitId }}</p>
  </div>
  <ng-template #notFoundTemplate>
    <p> {{'Build information not found' | translate}} </p>
  </ng-template>
</div>